<template>
  <span>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="getListFromApi(0)" color="primary" small dense>mdi-chart-bar</v-icon>
            </template>
            <span>Investor's expo distribution</span>
          </v-tooltip>          
          <v-dialog v-model="listDialog" max-width="600px">
              <v-card class="px-7"  style="background: #121212;">
                <v-card-title>
                    {{title}}   
                    <v-spacer></v-spacer>
                    <v-btn color="primary" icon @click="listDialog = false">
                        <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-row>
                  <v-col cols="12" v-if="listLoad">
                    <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" v-else>
                    <v-tabs background-color="#233767" v-model="tab">
                    <v-tab
                      v-for="item in itemsTab"
                      :key="item.tab"
                    >
                      {{ item.tab }}
                    </v-tab>                      

                    <v-tabs-items v-model="tab">
                      <v-tab-item v-for="item in itemsTab" 
                      :key="item.tab">
                        <v-card style="background: #121212;">
                          <v-card-text>
                            <ul v-if="item.insights!=null">
                              <li v-if="item.insights.general !=''">{{item.insights.general}}</li>
                              <li>{{item.insights.portfolio}}</li>
                            </ul>
                          </v-card-text>
                          <expo-bar-chart v-if="!listLoad" :chartData="item.chartData" :height="250" > </expo-bar-chart>
                        </v-card>
                      </v-tab-item>   
                    </v-tabs-items>
                  </v-tabs>
                  </v-col>
                </v-row>
                <v-card-actions>    
                  <v-spacer></v-spacer>             
                  <v-btn color="primary" text @click="listDialog = false">Close</v-btn>
                </v-card-actions>
              </v-card>                
          </v-dialog>
    </span>
</template>

<script>
  import ExpoBarChart from "@/components/ExpoBarChart";
  export default {
    name: 'PortfolioAnalyzeComponentRecentInvestorsExpand',
    props: ['ptf','type','expo','title'],
    components: {
      ExpoBarChart
    },        
    data() {
      return {
        listDialog: false,
        listLoad: true,
        errorbar: false,
        chartData:null,        
        chartDataSimilar:null,
        chartDataPeerGroup:null,        
        tab:null,
        insights:null,        
        insightsSimilar:null,
        insightsPeerGroup:null,   
        itemsTabAll: [ 
          { tab: 'Peer Group', 'id':0, chartData: null, insights: null },
          { tab: 'Similar Investors','id':1, chartData: null, insights: null },
          { tab: 'Classification','id':2, chartData: null, insights: null },
        ],             
        itemsTab: [],
        visibleIds: [0,1,2],         
      }
    },
    watch: {
      tab(val) {
        //console.log(this.itemsTab[val])
        this.getListFromApi(val);        
      }
    },
    mounted() {
      this.itemsTab = this.itemsTabAll
    },
    methods: {          
      async getListFromApi(tab) {
        this.listDialog= true
        var body = {};
        if (this.itemsTab[tab]["id"] === 0 ) {
          // We are requesting peer group investors tab
          body = {classification:-2};
          if (this.itemsTab[tab]["chartData"] != null) {
            return 1;
          }
        } else if (this.itemsTab[tab]["id"] === 1 ) {
          // We are requesting similar investors tab
          body = {classification:-1};
          if (this.itemsTab[tab]["chartData"] != null) {
            return 1;
          }
        } else if (this.itemsTab[tab]["chartData"] != null) {
            return 1;
          }
        //console.log(tab)
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-user-ptf-expo-distribution/'  + self.type +'/' + self.ptf +'/' + self.expo,body,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.visibleIds = response.data.visible; // works because tab 0 when no peer group, will return similar investors.
          self.itemsTab = self.itemsTab.filter(function (el) {
            return self.visibleIds.includes(el.id) ;
          });
          self.itemsTab[tab]["chartData"]= response.data.chart
          self.itemsTab[tab]["insights"]= response.data.text
          // if ("classification" in body ) {
          //   if (body.classification===-2){
          //     self.chartDataPeerGroup = response.data.chart
          //     self.insightsPeerGroup = response.data.text
          //   }
          //   else if (body.classification===-1){
          //     self.chartDataSimilar = response.data.chart
          //     self.insightsSimilar = response.data.text
          //   }
          //   else { 
          //     self.chartData = response.data.chart
          //     self.insights = response.data.text
          //   }
          // }
          // else {
          //   self.chartData = response.data.chart 
          //   self.insights = response.data.text
          // }
          self.listLoad = false
        }).catch(function (/*error*/) {
          self.listLoad = false

        })
      }
    },
  }
</script>